import {
  React,
  Input,
  Heading,
  Subtitle,
  Text,
  Shortcut,
  Button,
  Row,
  Col
} from "mondrian-react";
import { useEffect } from "react";
import { differenceInDays } from "date-fns";
import { handleMesMask } from "utils/handleMesMask";
import { logger } from "utils/logger";
import useIsTotem from "hooks/useIsTotem";
import { isMobile } from "react-device-detect";
import { DestaquePix } from "components/DestaquePagamento";

//Style
import "./styles.scss";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";
import { ShortcutRedirectLogin } from "components/ShortcutRedirectLogin";
import useIsPJ from "hooks/useIsPJ";
import { ExclusiveOfferBanner } from "components/ExclusiveOfferBanner";

const FaturaStep = ({
  changeNumber,
  numberPhone,
  optionsFatura,
  setCodeBarAlert,
  setPaymentCodeBarOpen,
  setFaturaSelect,
  setPaymentPixOpen,
  changeNumberMsisdn
}) => {
  const [faturaSelect, setFaturaSelectOn] = React.useState(
    optionsFatura[0].paymentDueDate
  );
  const splittedDate = optionsFatura
    .find((i) => i.paymentDueDate === faturaSelect)
    .paymentDueDate.split("-");
  const formattedDate = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;

  const dataVencimento = new Date(splittedDate[0], splittedDate[1] - 1, splittedDate[2]);
  const today = new Date();
  const diffDays = differenceInDays(dataVencimento, today);
  const formattedLabelDate = `${handleMesMask(splittedDate[1])} • ${splittedDate[0]
    }`;
  const isTotem = useIsTotem();
  const isPJ = useIsPJ()

  useEffect(() => {
    reportPageViewGA4({ customTitle: 'detalhes_de_fatura' })
  }, [])

  useEffect(() => {
    setFaturaSelect(optionsFatura[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row>
        <Col xs={12} lg={3} className="mdn-Offset-lg-1 mdn-u-flex mdn-u-alignItems-xs-center">
          <Heading xs className="textSelect">
            Selecione o mês da fatura desejada:
          </Heading>
        </Col>
        <Col xs={12} lg={3} className="mdn-u-flex mdn-u-alignItems-xs-center">
          <Input
            select
            options={optionsFatura}
            value={faturaSelect}
            onChange={(e) => {
              setFaturaSelectOn(e.target.value);
              setFaturaSelect(
                optionsFatura.find((i) => i.paymentDueDate === e.target.value)
              );
              logger({ name: "ChangeFatura" });
              reportGA4({ customTitle: 'detalhes_de_fatura:mudanca_mes_fatura' })
            }}
          >
            Mês
          </Input>
        </Col>
        <Col xs={12} lg={4} className="mdn-u-flex mdn-u-alignItems-xs-center mdn-u-justifyContent-xs-start mdn-u-justifyContent-lg-end mdn-u-marginTop--xs mdn-u-marginBottom--xxs">
          <Text body className="mdn-u-flex mdn-u-alignItems-xs-center">
            Fatura desta linha: <span className="titularLinha">{numberPhone}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={3} className="mdn-Offset-lg-1">
          <Subtitle xs className="textTitular">
            {formattedLabelDate}
          </Subtitle>
          <Heading xl className="textMoney">
            R${" "}
            {parseFloat(
              optionsFatura.find((i) => i.paymentDueDate === faturaSelect)
                .billAmount
            )
              .toFixed(2)
              .replace(".", ",")}
          </Heading>
          <Subtitle xs className="textDue">
            Vencimento: {formattedDate}
          </Subtitle>
          <div className={`mdn-Tag mdn-Tag-category mdn-Tag--feedback ${diffDays >= 0 ? 'status-aberto' : 'status-atrasada'}`}>
            <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm"></i>
            <p className="mdn-Text">{diffDays >= 0 ? 'Aguardando pagamento' : 'Atrasada'}</p>
          </div>
        </Col>
      </Row>
      {isPJ && (
        <Row>
          <Col xs={12} lg={6} className="mdn-Offset-lg-1">
            <div
              className={
                "WarningFullWidth StepMarginZero mdn-Tag mdn-Tag--feedback mdn-u-marginTop--md"
              }
            >
              <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm"></i>
              <p className="WarningFullWidth">Atenção! Em caso de multas ou acordos,
                será necessário acessar a Minha Claro móvel empresas
                para consultar a fatura detalhada.
              </p>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1">
          <Subtitle sm className="textSub">
            Pague sua fatura
          </Subtitle>
          <div className={isMobile ? "divScroll" : ""}>
            <Shortcut
              onClick={() => {
                setPaymentPixOpen(true);
                logger({ name: "PagarComPIX" });
                reportGA4({ customTitle: 'pague_sua_fatura:pagar_com_pix' })
              }}
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-pix mdn-Icon--md"}
            >
              Pagar com <br />
              Pix
            </Shortcut>
            <Shortcut
              onClick={() => {
                setPaymentCodeBarOpen(true);
                logger({ name: "PagarComCodigoDeBarras" });
                reportGA4({ customTitle: 'pague_sua_fatura:exibir_codigo_de_barras' })
              }}
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-codigo-de-barras mdn-Icon--md"}
              inverse
            >
              Exibir código de barras
            </Shortcut>
            {!isPJ && (
              <>
                <ShortcutRedirectLogin
                  loggerName="PagueSuaFatura"
                  loggerElement="CartaoDeCredito"
                  customTitle="pague_sua_fatura:cartao_de_credito"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-cartao-de-credito mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/mcpf/index.html#.html/faturas/minhas-faturas"
                >
                  Cartão de crédito
                </ShortcutRedirectLogin>
                <ShortcutRedirectLogin
                  loggerName="PagueSuaFatura"
                  loggerElement="RedirectParcelamentoDeFaturas"
                  customTitle="pague_sua_fatura:parcelamento_de_faturas"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=FaturasMinhasFaturas"
                >
                  Parcelamento de faturas
                </ShortcutRedirectLogin>
                <ShortcutRedirectLogin
                  loggerName="PagueSuaFatura"
                  loggerElement="RedirectInformarPagamento"
                  customTitle="pague_sua_fatura:informar_pagamento"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=FaturasMinhasFaturas"
                >
                  Informar pagamento
                </ShortcutRedirectLogin>
              </>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1">
          {!isTotem && !isPJ &&
            <div className={'facilidadesMinhaClaro'}>
              <Subtitle sm className="textSub">
                Facilidades no Minha Claro móvel
              </Subtitle>
              <div>
                <ShortcutRedirectLogin
                  loggerName="FacilidadesMCM"
                  loggerElement="RedirectFaturaDetalhada"
                  customTitle="facilidades:fatura_detalhada"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=FaturasMinhasFaturas"
                >
                  Fatura detalhada
                </ShortcutRedirectLogin>
                <Shortcut
                  href="https://planoscelular.claro.com.br/?utm_source=minhaclaro-fatura_web&utm_medium=plp-cliente&utm_campaign=gatilhomudeseuplano"
                  target="_blank"
                  onClick={() => {
                    logger({ name: "FacilidadesMCM", element: "RedirectMudeSeuPlano" })
                    reportGA4({ customTitle: 'facilidades:mude_seu_plano' })
                  }}
                  inverse
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                >
                  Mude seu plano
                </Shortcut>
                <ShortcutRedirectLogin
                  loggerName="FacilidadesMCM"
                  loggerElement="RedirectLoja"
                  customTitle="facilidades:loja"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=Loja"
                >
                  Loja
                </ShortcutRedirectLogin>
                <ShortcutRedirectLogin
                  loggerName="FacilidadesMCM"
                  loggerElement="RedirectSuporteTecnico"
                  customTitle="facilidades:suporte_tecnico"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=AtendimentoGuiaSolucoes"
                >
                  Suporte técnico
                </ShortcutRedirectLogin>
                <ShortcutRedirectLogin
                  loggerName="FacilidadesMCM"
                  loggerElement="ClaroClube"
                  customTitle="facilidades:claro_clube"
                  className="card1"
                  icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                  inverse
                  redirect="https://minhaclaro.claro.com.br/?redirect-feature=ClaroClubeClienteCadastrado"
                >
                  Claro clube
                </ShortcutRedirectLogin>
              </div>
            </div>
          }
          <Subtitle xs></Subtitle>
          <Button secondary onClick={() => {
            changeNumber()
            reportGA4({ customTitle: 'detalhes_de_fatura:consultar_outro_numero' })
          }} className="consultarOutroNumero">
            Consultar outro número
          </Button>
        </Col>
      </Row>

      <Row>
        <Col xs={12} className="mdn-Offset-lg-1">
          <ExclusiveOfferBanner
            title="800 MEGA + Wi-Fi 6 + Skeelo + McAfee para 3 dispositivos"
            description="De R$ 109,90 por apenas R$ 99,90"
            url="https://planos.claro.com.br/empresas/checkout?affiliateId=CHp1HR1fp&internetId=1552,114"
            tag="oferta_exclusiva"
            icon="modem"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} className="mdn-Offset-lg-1 mdn-u-marginTop--xs">
          <DestaquePix changeNumber={changeNumber} msisdn={numberPhone} />
        </Col>
      </Row>
    </>
  );
};

export default FaturaStep;
